module.exports = __webpack_public_path__ + "img/no-booking.171ca0f0.png";